function showHideButton() {
    const addToCartButton = document.querySelector('.addToCartForm'),
        floatAddToCartButton = addToCartButton.querySelector('.form');
    
    if (window.innerWidth < 990) {
        let currentPosition = 0,
            buttonPosition = addToCartButton.offsetTop,
            buttonHeight = addToCartButton.offsetHeight,
            windowHeight = window.innerHeight;

        currentPosition = window.pageYOffset;
        
        if (currentPosition + windowHeight > buttonPosition && currentPosition - buttonHeight < buttonPosition) {
            console.log('remove')
            floatAddToCartButton.classList.remove('product-form--float');
        } else {
            console.log('add')
            floatAddToCartButton.classList.add('product-form--float');
        }
    } else {
        floatAddToCartButton.classList.remove('product-form--float');
    }

}
// document.onscroll = showHideButton;
// window.onresize = showHideButton;
// document.addEventListener('shopify:section:load', showHideButton())